import React from 'react'
import styled from 'styled-components';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';

const HamburgerBtn = styled.div`
  position: relative;
  width: 4.1em;
  height: 2.8em;
  transition: .5s ease-in-out;
  cursor: pointer;
  //margin-left: -1.3em;
  margin-left: auto;
  //top: .6em;
  
  span {
    display: block;
    position: absolute;
    height: 0.6em;
    width: 100%;
    background-color: black;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .2s ease-in-out;
    border-radius: 1.5em;
    
    &:nth-child(1) {
      top: 0;
    }
    
    &:nth-child(2), &:nth-child(3) {
      top: 1.1em;
    }
    
    &:nth-child(4) {
      top: 2.3em;
    }
  }
  
  &:${props => props.theme.hoverProperty} {
    span {
      background-color: ${props => props.theme.highlightColor};
    }
  }
  
  &.is-open {
    span {
      &:nth-child(1) {
        top: 1.8em;
        width: 0%;
        left: 50%;
      }

      &:nth-child(2) {
        transform: rotate(45deg);
      }

      &:nth-child(3) {
        transform: rotate(-45deg);
      }

      &:nth-child(4) {
        top: 1.8em;
        width: 0;
        left: 50%;
      }
    }
  }
`;

const HamburgerButtonContainer = (props: any) => {
  const {
    _onShowClick,
  } = props;

  return (
    <HamburgerBtn className={`${props.isOpen ? 'is-open' : ''}`} onClick={() => _onShowClick()}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </HamburgerBtn>
  )
};

const mapStateToProps = ({ navigationReducer }: any) => {
  const {
    visible,
  } = navigationReducer;

  return {
    visible
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    _onShowClick: () => {
      dispatch(NavigationAction.show());
    }
  }
};

export const HamburgerButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(HamburgerButtonContainer);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/hamburger-btn/HamburgerButton.tsx